import { User } from '../api/graphql/generated';

const getUsername = (user?: User): string | undefined => {
  const username =
    user?.firstName && user?.lastName
      ? `${user?.firstName} ${user?.lastName}`
      : user?.email;
  return username;
};

export { getUsername };
